import { loadScript } from '../utils/accept';

export default {
    namespaced: true,

    state() {
        return {
            acceptPromise: null,
        };
    },

    mutations: {
        setAccept(state, acceptPromise) {
            state.acceptPromise = acceptPromise;
        },
    },

    actions: {
        loadAccept({ commit, state }, acceptJSScript) {
            if(state.acceptPromise !== null){
                return;
            };
            commit('setAccept', loadScript(acceptJSScript));
        },
        dispatchAcceptData({state}, secureData) {
            return new Promise((resolve) => {
                state.acceptPromise.then((accept) => {
                    accept.dispatchData(secureData, (data) => {
                        resolve(data);
                    });
                });
            });
        },
    }
};